var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget',{attrs:{"title":'App - '+_vm.app.app_name,"icon":"fa-th-large","no-padding":true}},[_c('div',{staticClass:"addon-app-body",style:({height: _vm.iframeHeight})},[_c('iframe',{attrs:{"src":_vm.iframeSrc}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }